import React from 'react';
import bg8 from '../../assets/images/background/bg-8.png';
import bg7 from '../../assets/images/background/bg-7.png';
import hygienicIcon from '../../assets/images/resource/Hygienic-icon.png';
import cafeIcon from '../../assets/images/resource/cafe-icon.png';
import chefsIcon from '../../assets/images/resource/chefs-icon.png';
import celebrationIcon from '../../assets/images/resource/celebration-icon.png';

function Whyus() {
  const whyData = [
    {
      icon: hygienicIcon,
      title: 'Hygienic Food',
      text: 'We serve fresh, high-quality dishes crafted to delight your senses',
    },
    {
      icon: cafeIcon,
      title: 'Cafe Vibe',
      text: 'Every corner of our space offers a refreshing escape', 
    },
    {
      icon: chefsIcon,
      title: 'Skilled Chefs',
      text: `Savor the art of fine dining with our master chef's exquisite creations`,
    },
    {
      icon: celebrationIcon,
      title: 'Celebration Hall',
      text: 'Your perfect venue for unforgettable moments and events',
    },
  ];

  return (
    <>
      <section className="why-us">
        <div className="left-bg">
          <img src={bg8} alt="" title="" />
        </div>
        <div className="right-bg">
          <img src={bg7} alt="" title="" />
        </div>
        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle">
              <span>why choose us</span>
            </div>
            <div className="pattern-image">
              <img
                src={require('../../assets/images/icons/separator.svg').default}
                alt="mySvgImage"
              />
            </div>

            <h2>Our Strength</h2>
          </div>
          <div className="row clearfix">
            {whyData.map((data, index) => (
              <div key={index} className="why-block col-xl-3 col-lg-6 col-md-6 col-sm-12"
              >
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay={`${index * 300}ms`}
                >
                  <div className="icon-box">
                    <img src={data.icon} alt="" />
                  </div>
                  <h4>{data.title}</h4>
                  <div className="text">{data.text}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Whyus;
